import OverflowMenu from '@/components/_common/OverflowMenu/OverflowMenu';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { InventoryFileEntity } from '@/redux/slices/slice_types';

interface OutputVersionOverflowMenuProps {
  files: InventoryFileEntity[];
  group: any;
  onEdit: () => void;
  onDuplicate: () => void;
  onRemove: () => void;
}

const OutputVersionOverflowMenu = ({ files, onDuplicate, onRemove, onEdit }: OutputVersionOverflowMenuProps) => {
  return (
    <OverflowMenu>
      <OverflowMenuItem onClick={onEdit}>
        <PolarisIcon icon="edit" height={18} style={{ color: 'var(--error-main)' }} />
        Edit
      </OverflowMenuItem>
      <OverflowMenuItem onClick={onDuplicate}>
        <PolarisIcon icon="copy" height={18} /> Copy to Selections
      </OverflowMenuItem>
      <OverflowMenuItem onClick={onRemove} sx={{ color: 'error.main' }}>
        <PolarisIcon icon="delete" height={20} style={{ color: 'var(--error-main)' }} />
        Remove
      </OverflowMenuItem>
    </OverflowMenu>
  );
};

export default OutputVersionOverflowMenu;
